function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var _logo;
  var mediaQueries = _ref.mediaQueries;
  return {
    logo: (_logo = {
      display: 'inline-block',
      width: '200px',
      height: '35px'
    }, _defineProperty(_logo, mediaQueries.breakpointTablet, {
      display: 'block',
      width: '130px',
      height: '24px',
      margin: '3px auto 0'
    }), _defineProperty(_logo, '& span', _defineProperty({
      display: 'block',
      height: '35px'
    }, mediaQueries.breakpointTablet, {
      height: '24px'
    })), _logo)
  };
});